import objectPath from 'object-path';
import { createSelector } from 'reselect';

import { getCouncilByLga, getAddress } from 'utils';

const stratasSelector = (state) => state.stratas.items || [];
const councilsSelector = (state) => state.councils.items || [];
const orderSelector = (state) => state.pendingOrder.pending || {};
const ordersSelector = (state) => state.orders.items || [];

export const addressSelector = createSelector(
  [orderSelector],
  ({
    address_unit = '',
    address_lot = '',
    address_street_no = '',
    address_street_1 = '',
    address_street_2 = '',
    address_suburb = '',
    address_state = '',
    address_postcode = '',
    address_ct = '',
    address_plan_lot_section = ''
  }) => ({
    address_unit,
    address_lot,
    address_street_no,
    address_street_1,
    address_street_2,
    address_suburb,
    address_state,
    address_postcode,
    address_ct,
    address_plan_lot_section
  })
);

export const titleSelector = createSelector(
  [orderSelector],
  (order) => (order.title && order.title.name ? order.title : false)
);

export const councilSelector = createSelector(
  [councilsSelector, orderSelector],
  (councils, order) => {
    return getCouncilByLga(councils, order.selected_council) || {};
  }
);

export const strataSelector = createSelector(
  [stratasSelector, orderSelector],
  (stratas, order) => {
    return stratas.find((strata) => strata.id === order.selected_strata);
  }
);

export const certificateSelector = createSelector(
  [councilSelector, orderSelector],
  (council, order) =>
    council &&
    council.items &&
    council.items.find((cert) => cert.id === order.selected_certificate)
);

export const strataCertSelector = createSelector(
  [strataSelector, orderSelector],
  (strata, order) =>
    strata &&
    strata.items &&
    strata.items.find((cert) => cert.id === order.selected_strata_cert)
);

export const globalxAddressSelector = createSelector(
  [orderSelector],
  (order) => {
    const folio = objectPath.get(order, 'globalx_meta.volumeFolio');

    //SA format
    if (folio) return `${folio.volFolPrefix}${folio.volume}-${folio.folio}`;

    const planParcel     = objectPath.get(order, 'globalx_meta.lotPlan');
    const titleReference = objectPath.get(order, 'globalx_meta.titleReference');

    //WA format
    if (planParcel && titleReference) {
      return `${titleReference}${planParcel.planType}${planParcel.planNumber}`;
    }

    return '';
  }
);

export const completeOrderSelector = createSelector(
  [orderSelector, ordersSelector],
  (pending, orders) => orders.find(({ id }) => id === pending.id)
);

export const addressDisplaySelector = createSelector(
  [ orderSelector ],
  (order) => {
    var propertyAddress = (
      order.globalx_meta && 
      order.globalx_meta.propertyLocation && 
      order.globalx_meta.propertyLocation[0]
    );

    return propertyAddress || getAddress(order);
  }
);